import React, { FC, useEffect, useState } from "react";
import LocationInput from "../LocationInput";
import GuestsInput from "../GuestsInput";
import StayDatesRangeInput from "./StayDatesRangeInput";
import { useSelector } from "react-redux";
import { RootState } from "redux/store";

const StaySearchForm = ({ screenType }: { screenType?: string }) => {
  const storedSearchData = useSelector(
    (state: RootState) => state.search.searchedData
  );
  const {
    latitude,
    longitude,
    locationData,
    startDate: start,
    endDate: end,
    totalGuests,
  } = storedSearchData || {};

  const [userLocation, setUserLocation] = useState<{
    latitude: number | null;
    longitude: number | null;
    locationData: any;
  } | null>(
    screenType === "searchInside" ? { latitude, longitude, locationData } : null
  );
  const parseValidDate = (dateString: string | undefined | null): Date | null => {
    if (!dateString) return null;
    const date = new Date(dateString);
    return isNaN(date.getTime()) ? null : date;
  };

  const [startDate, setStartDate] = useState<Date | null>(
    screenType === "searchInside" ? parseValidDate(start) : new Date()
  );
  const [endDate, setEndDate] = useState<Date | null>(
    screenType === "searchInside" ? parseValidDate(end) : null
  );


  const [selectedLocation, setSelectedLocation] = useState<any>(
    userLocation ? userLocation : null
  );
  const [locationError, setLocationError] = useState<string>("");
  const [dateError, setDateError] = useState<any>(
    startDate && endDate ? "" : ""
  );
  const [guests, setGuests] = useState<number>(0);
  const [guestsError, setGuestsError] = useState<any>("");

  const validateForm = () => {
    let isValid = true;
    if (!selectedLocation) {
      setLocationError("Please select a location.");
      isValid = false;
    } else {
      setLocationError("");
    }
    if (!startDate || !endDate) {
      setDateError("Please select end dates.");
      isValid = false;
    } else {
      setDateError("");
    }
    if (!guests || guests < 1) {
      setGuestsError("Please select at least one guest.");
      isValid = false;
    } else {
      setGuestsError("");
    }
    return isValid;
  };

  useEffect(() => {
    if (screenType === "searchInside") {
      setUserLocation({ latitude, longitude, locationData });
      setSelectedLocation({ latitude, longitude, locationData });
      setStartDate(parseValidDate(start));
      setEndDate(parseValidDate(end));
      setGuests(totalGuests);
    }
  }, [latitude, longitude, locationData, start, end, screenType, totalGuests]);

  const renderForm = () => {
    return (
      <form className="w-full relative mt-8 flex rounded-full shadow-xl dark:shadow-2xl bg-white dark:bg-neutral-800 ">
        <LocationInput
          className="flex-[1.5]"
          address={userLocation?.locationData?.street}
          setUserLocation={setUserLocation}
          setSelectedLocation={setSelectedLocation}
          error={locationError}
          setError={setLocationError}
        />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <StayDatesRangeInput
          className="flex-1"
          startDate={startDate}
          setStartDate={setStartDate}
          endDate={endDate}
          setEndDate={setEndDate}
          dateError={dateError}
          setDateError={setDateError}
        />
        <div className="self-center border-r border-slate-200 dark:border-slate-700 h-8"></div>
        <GuestsInput
          className="flex-[1.5]"
          userLocation={userLocation}
          selectedLocation={selectedLocation}
          startDate={startDate}
          endDate={endDate}
          validateLocation={validateForm}
          guestsError={guestsError}
          setGuests={setGuests}
          setGuestsError={setGuestsError}
          screenType={screenType}
          guestNumber={guests}
        />
      </form>
    );
  };

  return renderForm();
};

export default StaySearchForm;
